import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=4de71f3a&scoped=true&"
import script from "./Bottom.vue?vue&type=script&lang=js&"
export * from "./Bottom.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Bottom.vue?vue&type=style&index=0&id=4de71f3a&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4de71f3a",
  "eb10d8ac"
  
)

export default component.exports